import React from 'react';

export default class Observaciones extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount(){}

  render(){
    const {show, editar, datos} = this.props;
    return(
      <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
        <div style={{
          display:'flex', flexDirection:'row', width:'calc(100% - 30px)',
          padding:'10px 15px', backgroundColor:'#00b1e9', color:'white',
          fontSize:18, fontFamily:'Barlow_Condensed', fontWeight:'bold'
        }}>
          <strong>10. </strong> &nbsp;
          Observaciones
        </div>
        <div style={{
          display: show ? 'flex' : 'none',
          flexDirection:'column', width:'100%', margin:'10px 0'
        }}>
          <textarea
            style={{resize:'none', fontFamily:"Barlow_Condensed"}}
            value={datos.observaciones}
            onChange={(e) => editar('observaciones', e.target.value)}
            placeholder="Describa observaciones sobre la entrevista"
          ></textarea>
        </div>
      </div>
    )
  }
}
